export const HOST = "http://8.218.238.248";

export const DOMAIN = "http://8.218.238.248";

export const SERVERPATH = "/admin";

export const USERINFO = "__data__login_user";

export const UNIT = [
  { label: "盒（box）", value: "BOX" },
  { label: "个（pcs）", value: "PCS" },
  { label: "套（set）", value: "SET" },
  { label: "包（bag）", value: "BAG" },
  { label: "卡（kar）", value: "KAR" },
  { label: "双（ pair）", value: "PAIR" },
  { label: "打（dozen）", value: "DOZEN" },
  { label: "米（meter）", value: "METER" },
  { label: "平方米（square meter）", value: "SQUAREMETER" },
];

export default {
  HOST,
  SERVERPATH,
  USERINFO,
};
